
import { computed, defineComponent, nextTick, reactive, ref, toRefs, watch } from 'vue'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
export default defineComponent({
  props: {
    // src: {
    //   type: String,
    //   default: () => {
    //     return ''
    //   }
    // },
    // modalvisible: {
    //   type: Boolean,
    //   default: () => {
    //     return false
    //   }
    // },
    // title: {
    //   type: String,
    //   default: () => {
    //     return ''
    //   }
    // },
    // width: {
    //   type: String,
    //   default: () => {
    //     return '1040px'
    //   }
    // }
  },
  setup(props: any, context: any) {
    const store = useStore()
    const visible = ref<boolean>(false)
    type pageDataType = {
      modalsrc: string
      modalvisible: boolean
      title: string
      width: string
      getContainer: any
    }
    const pageData: any = reactive({
      modalsrc: '',
      modalvisible: false,
      title: '',
      width: '948px',
      getContainer: () => document.querySelector('.f10wrapper')
    })
    const showModal = () => {
      // visible.value = true
    }

    const handleOk = (e: MouseEvent) => {
      store.commit('setIframeModalInfo', {
        modalsrc: '',
        modalvisible: false,
        title: '',
        width: '948px'
      })
    }
    watch(
      () => store.state.iframeModalInfo,
      (val: any) => {
        Object.keys(val).forEach((item) => {
          pageData[item] = val[item]
        })
      },
      {
        deep: true,
        immediate: true
      }
    )
    computed
    return {
      ...toRefs(pageData),
      ...mapMutations(['setIframeModalInfo']),
      showModal,
      handleOk
    }
  }
})
